/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import ApplicationStore from "@Store";


import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import CHANGE_API_REQUEST_TOKEN_ACTION from "@Actions/Api/ChangeApiRequestTokenValue";


import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";


import prepareApiRequestMethod from "@Services/Utilities/Requests/Method/Prepare";
import prepareApiRequestHeaders from "@Services/Utilities/Requests/Headers/Prepare";
import prepareApiRequestBody from "@Services/Utilities/Requests/Body/Prepare";

import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";


import REQUEST_METHODS_TYPE from "@Services/Interfaces/Http/Request/Methods";


export const REST_API_REQUEST = async (
    URL: string,
    DATA: any,
    TOKEN: AUTHORIZATION_TOKEN_INTERFACE | null = null,
    METHOD: REQUEST_METHODS_TYPE = "POST"
): Promise<Response> => {

    let RESPONSE;

    const REQUEST_METHOD: string = prepareApiRequestMethod(METHOD)
    const REQUEST_HEADERS: HeadersInit = prepareApiRequestHeaders(TOKEN);
    const REQUEST_BODY: string = prepareApiRequestBody(DATA);

    await ApplicationStore.dispatch(CHANGE_API_REQUEST_STATUS_ACTION(true));

    try {

        RESPONSE = await fetch(URL, {
            method: REQUEST_METHOD,
            headers: REQUEST_HEADERS,
            body: REQUEST_BODY
        });

        ApplicationStore.dispatch(CHANGE_API_REQUEST_TOKEN_ACTION(
            prepareRestApiRequestToken(RESPONSE.headers)
        ));

    } catch (e) {

        const RESPONSE_BODY = new FormData();
        RESPONSE_BODY.append("UserMessage", "Wystąpił nieokreślony błąd - skontaktuj się z CDOK");

        RESPONSE = new Response(
            RESPONSE_BODY,
            {status: 400, statusText: String(e)}
        );

    }

    await ApplicationStore.dispatch(CHANGE_API_REQUEST_STATUS_ACTION(false));

    return RESPONSE;

};


export default REST_API_REQUEST;
